
import React, { useState } from 'react';

export default function NewsletterSignup() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // Basic email validation
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus('error');
      return;
    }

    setStatus('loading');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const res = await fetch('https://readdy.ai/api/form/d63aip5anburc340qdj0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });

      if (res.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch (err) {
      console.error('Newsletter signup failed:', err);
      setStatus('error');
    }
  };

  return (
    <section className="py-16 bg-gradient-to-br from-teal-50 to-orange-50">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <div className="w-14 h-14 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-6">
          <i className="ri-mail-send-line text-white text-2xl"></i>
        </div>

        <h4 className="text-2xl font-bold text-gray-900 mb-3">
          <a href="#newsletter" className="hover:text-teal-600 transition-colors">
            Get Bookkeeping Tips Delivered Weekly
          </a>
        </h4>

        <p className="text-gray-600 mb-8 text-base">
          Join El Paso business owners who receive our free weekly insights on QuickBooks,
          financial management, and business growth strategies.
        </p>

        <form
          id="blog-newsletter-form"
          data-readdy-form="" /* added empty string to make it a valid JSX attribute */
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto"
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email address"
            className="flex-1 px-5 py-3 rounded-full border border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
            required
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="bg-teal-500 text-white px-8 py-3 rounded-full text-sm font-medium hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60"
          >
            {status === 'loading' ? 'Subscribing...' : 'Subscribe'}
          </button>
        </form>

        {status === 'success' && (
          <p className="text-teal-600 text-sm mt-3">
            You’re subscribed! Check your inbox for our next update.
          </p>
        )}

        {status === 'error' && (
          <p className="text-red-500 text-sm mt-3">
            Please enter a valid email address and try again.
          </p>
        )}

        <p className="text-gray-400 text-xs mt-4">No spam. Unsubscribe anytime.</p>
      </div>
    </section>
  );
}
